import React, { type FC, useRef, useEffect } from 'react'

import { type BaseProps } from 'types'
import { isNil } from 'helpers/utils'
import styles from './style.scss'
import Button, { ButtonTypes } from 'components/Button'
import Text, { TextRoles } from 'components/Text'
import Messages from 'messages.app'

export enum ModalReturnValue {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export interface Props extends BaseProps {
  titleText: string
  open: boolean
  onClose?: (returnValue: ModalReturnValue) => void
  primaryBtnTitle: string
  secondaryBtnTitle?: string
}

const Modal: FC<Props> = ({
  titleText,
  children,
  open,
  onClose,
  primaryBtnTitle,
  secondaryBtnTitle,
}) => {
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    if (!isNil(dialogRef.current)) {
      if (open) {
        dialogRef.current.showModal()
      } else {
        dialogRef.current.close()
      }
    }
  }, [open])

  return (
    <dialog
      ref={dialogRef}
      className={styles['modal']}
      onClose={event => {
        const { returnValue } = event.target as HTMLDialogElement
        if (onClose) {
          onClose(returnValue as ModalReturnValue)
        }
      }}
    >
      <form method='dialog'>
        <header className={styles['modal-header']}>
          <Text role={TextRoles.Heading}>{titleText}</Text>
        </header>
        {children}
        <footer className={styles['modal-footer']}>
          {Boolean(secondaryBtnTitle) && (
            <Button
              buttonType={ButtonTypes.Text}
              type='submit'
              title={Messages.CANCEL}
              value={ModalReturnValue.SECONDARY}
            />
          )}
          <Button
            buttonType={ButtonTypes.Text}
            type='submit'
            title={primaryBtnTitle}
            value={ModalReturnValue.PRIMARY}
          />
        </footer>
      </form>
    </dialog>
  )
}

export default Modal
